"use client";

import {
    Benefits, CarCardsSection,
    FiveFacts,
    Hero,
    MaximumServiceOnePlace, MobileApp,
    NewLevelService,
    OilChange,
    ProfitableOffers, Reviews,
    SeeOnce,
    MapContacts,
    Separator
} from "@/shared/components/shared";
import { useEffect } from "react";

export default function Home() {
    useEffect(() => {
        // Восстанавливаем позицию скролла при возврате со страницы autofest
        const scrollPosition = sessionStorage.getItem('scrollPosition');
        if (scrollPosition) {
            setTimeout(() => {
                window.scrollTo({
                    top: parseInt(scrollPosition),
                    behavior: 'instant'
                });
                sessionStorage.removeItem('scrollPosition');
            }, 100);
        }
    }, []);

    return (
        <>
            <Hero/>
            <NewLevelService/>
            <section className="relative w-full h-[647px] lg:h-[1030px]">
                <video
                    autoPlay
                    muted
                    loop
                    playsInline
                    className="absolute inset-0 w-full h-[647px] lg:h-[1030px] object-cover"
                    poster="/images/video-poster.jpg"
                    id={'about'}
                >
                    <source
                        src="https://storage.yandexcloud.net/autogarantcity/formula/videos/hero-mobile.mp4"
                        type="video/mp4"
                        media="(max-width: 768px)"
                    />
                    <source
                        src="https://storage.yandexcloud.net/autogarantcity/formula/videos/hero.mp4"
                        type="video/mp4"
                    />
                    <div className="absolute inset-0 bg-[url('/video-poster.jpg')] bg-cover bg-center"></div>
                </video>
            </section>
            <OilChange/>
            {/*<MaximumServiceOnePlace/>*/}
            <ProfitableOffers/>
            <CarCardsSection/>
            <Benefits/>
            <FiveFacts/>
            <Separator/>
            <Reviews/>
            <MobileApp/>
            <MapContacts/>
            <SeeOnce/>
        </>
    );
};
